import { i18n } from '#react/i18n/create'
import { params } from '@nanostores/i18n'

export const panelMessageDefaults = {
  untitled: 'Untitled',
  nodeCopyString: ' copy',
  layers: 'Layers',
  expandLayer: 'Expand',
  collapseLayer: 'Collapse',
  pages: 'Pages',
  design: 'Design',
  code: 'Code',
  ai: 'AI',
  workspaceMode: 'Workspace mode',
  workspaceModeView: 'View',
  workspaceModeEdit: 'Edit',
  workspaceModeDev: 'Dev',
  workspaceModeViewTip: 'Browse and inspect without editing',
  workspaceModeEditTip: 'Design and edit the canvas',
  workspaceModeDevTip: 'Inspect selection and review code',
  assets: 'Assets',
  searchLocalComponents: 'Search local components',
  createdInThisFile: 'Created in this file',
  builtinLibrary: 'Built-in',
  builtinText: 'Markdown',
  builtinTextMode: 'Editor mode',
  expandBuiltinText: 'Expand editor',
  collapseBuiltinText: 'Shrink to panel',
  editAsRichText: 'Visual',
  editAsMarkdown: 'Markdown',
  headingText: 'text',
  textColor: 'Text color',
  textBackground: 'Highlight',
  insertLink: 'Link',
  insertImage: 'Insert image',
  linkURL: 'URL',
  orderedList: 'Ordered list',
  unorderedList: 'Unordered list',
  addMoreLibraries: 'Add more libraries',
  addLibraryTitle: 'Libraries',
  addLibraryHelp: 'Browse published libraries and add them to this file.',
  searchLibraries: 'Search libraries',
  libraryAlreadyAdded: 'Added',
  addingLibrary: 'Adding…',
  noRemoteLibraries: 'No remote libraries',
  cloudLibraries: 'Team library',
  revisionDescriptionPlaceholder: 'Describe what changed in this publish…',
  assetView: 'Asset view',
  gridView: 'Grid view',
  listView: 'List view',
  viewDetails: 'View details',
  assetLibraryBadge: 'Library',
  manageLibraries: 'Manage libraries',
  manageLibrariesDescription: 'Browse libraries and review updates available in this file.',
  reviewLibraryUpdates: 'Review library updates',
  enableLibrary: 'Enable library',
  disableLibrary: 'Disable library',
  removeLibrary: 'Remove library',
  noLibraries: 'No published libraries',
  libraryAssetCount: params('{count} assets'),
  libraryInstanceCount: params('Instances: {count}'),
  libraryUpdateAvailable: 'Update available',
  applyLibraryUpdate: 'Apply update',
  browseLibraries: 'Browse libraries',
  libraryUpdates: 'Updates',
  updateLibraryAsset: 'Update',
  updateAll: 'Update all',
  noLibraryUpdates: 'No library updates',
  showUpdatesForAllPages: 'Show updates for all pages',
  updateSelectedInstance: 'Update selected instance',
  currentVersion: 'Current',
  updatedVersion: 'Updated',
  sideBySide: 'Side by side',
  overlay: 'Overlay',
  comparisonMode: 'Comparison mode',
  overlayOpacity: 'Overlay opacity',
  loadingUpdatePreview: 'Loading update preview…',
  updateInstance: 'Update instance',
  libraryInstancePosition: params('{current} of {total} instances'),
  previousLibraryInstance: 'Previous instance',
  nextLibraryInstance: 'Next instance',
  libraryVariantFallbackWarning:
    'The exact variant is unavailable in the updated library. The default variant will be used.',
  reviewLibraryUpdate: 'Review library update',
  reviewLibraryUpdateDescription: 'Compare current and updated instances before accepting changes.',
  noLibraryAssetChanges: 'No asset changes',
  libraryUpdateImpact: params('{affected} affected instances · {fallback} variant fallbacks'),
  publishLibrary: 'Publish library',
  publishingLibrary: 'Publishing…',
  publishLibraryHelp: 'Publish this file’s components as an immutable revision.',
  manageSkills: 'Skills',
  manageSkillsAction: 'Manage skills',
  manageSkillsHelp:
    'Skill groups in this organization. Bind a group to one or more teams; teams do not own groups. Use Team remotes to fetch shared skill packages.',
  workdirNavSection: 'Workspace',
  skillsNavGroups: 'Skill groups',
  ownerSkills: 'Owner skills',
  skillsNavBound: 'Bound to teams',
  skillsNavTeamRemotes: 'Team remotes',
  skillsBoundTeamsLabel: 'Teams',
  skillsNoTeamRemotes: 'No team remotes yet.',
  noOwnerSkillGroups: 'No owner skill groups yet.',
  workdirTitle: 'Skill workspace',
  workdirHelp:
    'Lists platform skills from the skill API plus local skills (folders or zips). Checked = folder with SKILL.md; zips do not count. Platform uncheck deletes; local uncheck zips.',
  workdirRefresh: 'Refresh',
  workdirSelectSkillGroups: 'Skill groups',
  workdirTreeSkillGroups: 'Skill groups',
  workdirTreeOwner: 'Owner skills',
  workdirTreeLocal: 'Local',
  workdirChecking: 'Loading workspaces…',
  workdirNeedsIndexedDb: 'IndexedDB is required for Skill workspace in this browser.',
  workdirPathPlaceholder: '/absolute/path/to/project',
  workdirPathHelp:
    'Choose a project folder (browser folder access) or enter an absolute path on desktop.',
  workdirCreate: 'Add workspace',
  workdirAgentEnvs: 'Default agent environments',
  workdirAgentEnvsHelp:
    'Default install targets when enabling a skill. Each skill also has its own agent settings.',
  workdirSkillAgentEnvs: 'Skill agent environments',
  workdirSkillAgentEnvsHelp:
    'Choose which agent folders this skill uses. Checked locations must have a folder with SKILL.md.',
  workdirEmpty: 'No skill workspaces yet. Use + above to choose a project folder.',
  workdirActive: 'active',
  workdirActivate: 'Set as active',
  workdirDelete: 'Remove workspace',
  workdirDeleteConfirm:
    'Remove this skill workspace from IndexedDB? Files on disk are not deleted.',
  workdirSelectPrompt: 'Select a skill workspace to manage its skills.',
  workdirConfigPullAuto: 'Auto-pull on open',
  workdirConfigPullManual: 'Manual pull',
  workdirConfigHelp:
    'Configured in .open-pencil/config.json — pull: auto|manual and skillGroups: ["group-id"].',
  workdirGroupUnmatched: 'Not found in catalog',
  workdirLocalGroup: 'Local',
  workdirSkillsHelp:
    'Each visit rescans disk. On = folder with SKILL.md (zips ignored for checked). Platform uncheck deletes; local uncheck zips the folder. Use the gear on each skill for agent folders.',
  workdirFolderInaccessible:
    'Cannot read this folder. Re-add the workspace and grant folder access (browser picker or desktop path).',
  workdirNoSkills: 'No platform or local skills yet.',
  workdirSkillNoDescription: 'No description.',
  workdirSkillLocal: 'Local',
  workdirSkillPlatform: 'Platform',
  workdirSkillDelete: 'Remove local skill',
  workdirSkillDeleteConfirm:
    'Delete this skill from the selected agent environment folders? Cloud skills are not affected.',
  skillsScope: 'Scope',
  skillsFilterAll: 'All',
  skillsFilterPersonal: 'Personal',
  skillsFilterTeam: 'Team',
  skillsFilterAllTeams: 'All teams',
  skillsTeam: 'Team',
  skillName: 'Name',
  skillNameHelp:
    'Local folder name when downloaded (.agents/skills/<name>/, …). Letters (English/Chinese), digits, and - only — no spaces or other symbols.',
  skillNameEmpty: 'Name is required.',
  skillNameInvalid: 'Name may only contain letters (English/Chinese), digits, and - — no spaces or other symbols.',
  skillNameTooLong: 'Name must be at most 64 characters.',
  skillDescription: 'Description',
  skillContent: 'Skill Markdown',
  skillClipboardXmlHint:
    'Paste Figma or OpenPencil clipboard XML — it is stored in a markdown code fence as-is, and decoded to nodes only when AI uses the skill.',
  skillPackage: 'Files',
  skillContentPlaceholder:
    'Markdown instructions for codegen, e.g. preferred stack, naming, and file layout…',
  noSkills: 'No skills yet',
  noSkillsInGroup: 'No skills in this group yet.',
  noSkillGroupsPersonal: 'No personal skill groups yet.',
  noSkillGroupsTeam: 'No team remotes for this team.',
  createSkillGroupFirst: 'Create a skill group on the left, then add skills to it.',
  createSkill: 'New skill',
  createSkillGroup: 'New group',
  createSkillGroupHelpShort: 'Groups are organization-scoped and can bind multiple teams.',
  createSkillEntry: 'Create',
  newSkillGroupTitle: 'New skill group',
  newSkillGroupHelp:
    'Create a skill group in this organization. You can bind it to multiple teams afterward. Teams never contain skill groups.',
  newSkillGroupName: 'Group name',
  editSkillGroup: 'Edit group',
  editSkillGroupTitle: 'Edit skill group',
  bindSkillGroupTeams: 'Bound teams',
  skillGroupManagers: 'Managers',
  skillGroupManagersHelp: 'At least one manager is required. Organization managers can also manage this group.',
  skillGroupManagerUsername: 'Username',
  skillGroupManagerUsernameHelp: 'Enter the user’s username (or email).',
  skillGroupManagerUsernameEmpty: 'Username is required.',
  skillGroupManagerNotFound: 'No user found with that username.',
  skillGroupManagerUserId: 'Username',
  skillGroupAddManager: 'Add manager',
  skillGroupRemoveManager: 'Remove',
  skillGroupManagerAddFailed: 'Could not add manager.',
  skillGroupManagerRemoveFailed: 'Could not remove manager.',
  skillGroupRequiredFields: 'Group name is required',
  skillGroupNameHelp:
    'Letters (English/Chinese), digits, and - only — no spaces or other symbols.',
  skillGroupNameTakenInTeam: 'This name is already used by another skill group in the team.',
  skillGroupBoundTeamsEmpty: 'Not bound to any team yet.',
  skillGroupBoundTeamsCount: 'Bound to {count} teams',
  newSkillFile: 'New file',
  newSkillFolder: 'New folder',
  newSkillEntryName: 'Name',
  deleteSkillEntry: 'Delete',
  updateSkill: 'Save skill',
  savingSkill: 'Saving…',
  deleteSkill: 'Delete',
  deleteSkillConfirmTitle: 'Delete skill',
  deleteSkillConfirm: params(
    'Delete “{name}”? This cannot be undone. Files in the skill package will be removed.'
  ),
  deleteSkillConfirmAction: 'Delete',
  deleteSkillGroup: 'Delete group',
  shareSkillGroup: 'Bind teams',
  shareSkillGroupHelp: 'Bound teams see this group. Uncheck to unbind.',
  noTeamsToShareSkillGroup: 'Join a team (or be an org manager) to bind this group.',
  newSkillGroupPlaceholder: 'e.g. Design system',
  skillGroupSaveFailed: 'Could not create skill group',
  skillGroupUpdateFailed: 'Could not update skill group',
  skillGroupDeleteFailed: 'Could not delete skill group',
  skillGroupShareFailed: 'Could not update team binding',
  skillEntrySaveFailed: 'Could not create file or folder',
  skillEntryDeleteFailed: 'Could not delete file or folder',
  skillsLoadFailed: 'Could not load skills',
  skillsSaveFailed: 'Could not save skill',
  skillsDeleteFailed: 'Could not delete skill',
  skillsRequiredFields: 'Name and SKILL.md content are required',
  skillsTeamRequired: 'Choose a team for team skills',
  skillsOrgRequired: 'Select an organization before creating or sharing skills',
  allMySkills: 'Owner skills',
  skillOwnedBadge: 'Mine',
  skillFetchedBadge: 'Fetched',
  skillNameLocked: 'Name is taken from SKILL.md frontmatter and cannot be edited here',
  skillFrontmatterSyncHelp:
    'Synced with SKILL.md frontmatter description (supports multi-line YAML `|` blocks).',
  downloadSkill: 'Download',
  uploadSkillZip: 'Upload zip',
  uploadSkillFolder: 'Upload folder',
  uploadingSkill: 'Uploading…',
  skillDownloadFailed: 'Could not download skill package',
  skillUploadFailed: 'Could not upload skill package',
  shareSkillToTeam: 'Share to team',
  shareSkillToTeamHelp:
    'Opens a merge request. A team member merges it to publish or update the team remote.',
  skillShareMessage: 'Message',
  submitSkillShare: 'Request share',
  skillShareFailed: 'Could not create share request',
  fetchSkill: 'Fetch',
  skillFetchFailed: 'Could not fetch team skill',
  skillTeamRemote: 'Team remote',
  skillMergeRequests: 'Merge requests',
  skillMergeRequestsHelp: 'Pending shares into your teams. Merge to accept, like a git pull request.',
  noSkillMergeRequests: 'No open share requests.',
  mergeSkillRequest: 'Merge',
  rejectSkillRequest: 'Reject',
  cancelSkillRequest: 'Cancel',
  skillMergeFailed: 'Could not update share request',
  generateWithAI: 'Generate with AI',
  generateWithSkill: 'Generate with skill',
  generatingCode: 'Generating…',
  manageSkillsShort: 'Skills…',
  selectSkill: 'Skill',
  noSkillsForGenerate: 'Create a skill first',
  codeGenerateFailed: 'Code generation failed',
  configureAIForCodegen: 'Configure an AI provider in the AI panel first',
  codegenChatTitle: 'Code chat',
  codegenChatEmpty:
    'Ask for code changes. The chat plans steps first, then loads only the skills those steps need.',
  codegenChatNoSkills: 'no skills enabled',
  codegenChatSkillsActive: params('{count} skills'),
  codeTabSource: 'Code',
  codeTabGenerated: 'Code',
  codeTabPlan: 'Plan',
  codeTabSteps: 'Steps',
  codeTabTasks: 'Tasks',
  codeApplyGenerated: 'Apply to Code',
  codegenThinking: 'Thinking',
  codegenThought: 'Thought',
  codegenLoadingSkills: 'Loading skills',
  codegenSkillsUsed: params('Skills: {keys}'),
  agentTaskPending: 'Waiting',
  agentTaskRunning: 'Running',
  agentTaskDone: 'Done',
  agentTaskError: 'Failed',
  agentTaskParallel: 'parallel',
  agentTaskAfter: params('after {ids}'),
  libraryId: 'Library ID',
  libraryName: 'Library name',
  revisionDescription: 'Revision description',
  libraryPublishFailed: 'Failed to publish library',
  libraryChanges: 'Changes',
  searchLibraryChanges: 'Search changes',
  noLibraryChangesFound: 'No matching changes',
  libraryDestination: 'Destination',
  libraryChangeAdded: 'Added',
  libraryChangeModified: 'Modified',
  libraryChangeRenamed: 'Renamed',
  libraryChangeRemoved: 'Removed',
  loading: 'Loading…',
  cancel: 'Cancel',
  localLibraries: 'Local',
  storageLibraries: 'Storage',
  storageNotConfigured: 'Storage is not configured',
  storageLibrariesUnavailable: 'This storage provider does not support libraries',
  preferLibrary: 'Prefer this library',
  assetVariantSummary: params('{count} variants · {names}'),
  duplicateVariantValues: 'Duplicate variant values',
  variantPropertyName: 'Property name',
  variantPropertyValue: 'Initial value',
  addVariantProperty: 'Add variant property',
  addComponentProperty: 'Add property',
  propertySettings: 'Property settings',
  propertyValues: 'Values',
  propertyValue: 'Value',
  propertyTypeVariant: 'Variant',
  propertyTypeBoolean: 'Boolean',
  propertyTypeText: 'Text',
  propertyTypeInstanceSwap: 'Instance swap',
  propertyTypeSlot: 'Slot',
  applyBooleanProperty: 'Apply boolean property',
  detachBooleanProperty: 'Detach boolean property',
  noBooleanProperties: 'No boolean properties',
  applyTextProperty: 'Apply text property',
  detachTextProperty: 'Detach text property',
  noTextProperties: 'No text properties',
  applyInstanceSwapProperty: 'Apply instance swap property',
  detachInstanceSwapProperty: 'Detach instance swap property',
  noInstanceSwapProperties: 'No instance swap properties',
  applySlotProperty: 'Apply slot property',
  detachSlotProperty: 'Detach slot property',
  boundToProperty: params('Bound to {name}'),
  appliedToLayer: params('Applied to {name}'),
  noSlotProperties: 'No slot properties',
  createProperty: 'Create property',
  slotDescription: 'Description',
  slotDescriptionPlaceholder: 'How to use this slot',
  slots: 'Slots',
  createSlot: 'Create slot',
  removeSlot: 'Remove slot',
  slotName: 'Slot name',
  slotSettings: 'Slot settings',
  slotMinimumLayers: 'Minimum layers',
  slotMaximumLayers: 'Maximum layers',
  slotLayersNone: 'None',
  slotOnlyPreferredInstances: 'Only allow preferred instances',
  slotEmptyByDefault: 'By default, display empty slot',
  slotFillCounterAxis: "By default, fill items on slot's counter axis",
  slotPreferredInstances: 'Preferred instances',
  slotLearnMore: 'Learn more',
  addPreferredInstance: 'Add preferred instance',
  behaviour: 'Behaviour',
  addBehaviour: 'Add behaviour',
  removeBehaviour: 'Remove behaviour',
  behaviourButton: 'Button',
  behaviourTextField: 'Text field',
  behaviourTextarea: 'Textarea',
  behaviourNumberField: 'Number field',
  behaviourToggle: 'Toggle',
  behaviourSwitch: 'Switch',
  behaviourCheckbox: 'Checkbox',
  behaviourRadio: 'Radio',
  behaviourRadioGroup: 'Radio group',
  behaviourToggleGroup: 'Toggle group',
  behaviourSlider: 'Slider',
  behaviourProgress: 'Progress',
  behaviourTabs: 'Tabs',
  behaviourCollapsible: 'Collapsible',
  behaviourAccordion: 'Accordion',
  behaviourStates: 'States',
  behaviourAddStates: 'Add state variants',
  behaviourAddTextLayer: 'Add text layer',
  behaviourAddVariants: 'Add Off and On variants',
  behaviourAddSlot: params('Add {name} slot'),
  behaviourChooseProperty: 'Choose property',
  behaviourChooseSlot: 'Choose slot',
  behaviourComplete: 'Ready',
  behaviourNextStep: params('Still needed: {names}.'),
  addSlotInstances: 'Add instances',
  slotDefault: 'Default',
  slotModified: 'Modified',
  slotItemCount: params('{count} items'),
  resetSlot: 'Reset slot',
  deleteSlotContents: 'Delete contents',
  slotActions: params('{name} actions'),
  searchInstances: 'Search components',
  preferredInstances: 'Preferred',
  allInstances: 'All components',
  instanceSwapSlot: 'Slot',
  textContent: 'Content',
  defaultVariantPropertyName: 'Property 1',
  defaultVariantPropertyValue: 'Default',
  defaultBooleanPropertyName: 'Boolean',
  defaultTextPropertyName: 'Text',
  defaultInstanceSwapPropertyName: 'Instance',
  defaultSlotPropertyName: 'Slot',
  addVariant: 'Add variant',
  duplicateVariant: 'Duplicate variant',
  removeVariant: 'Remove variant',
  removeVariantProperty: 'Remove variant property',
  moveVariantPropertyUp: 'Move variant property up',
  moveVariantPropertyDown: 'Move variant property down',
  moveVariantValueUp: 'Move variant value up',
  moveVariantValueDown: 'Move variant value down',
  noVariantProperties: 'No variant properties',
  variantConflictHelp: 'Each variant needs a unique combination of property values',
  openDocumentation: 'Open documentation',
  noLocalComponents: 'No local components',
  componentSet: 'Component set',
  component: 'Component',
  insertInstance: 'Insert instance',
  description: 'Description',
  documentation: 'Documentation',
  openDocs: 'Open docs',
  properties: 'Properties',

  xAxis: 'X Axis',
  yAxis: 'Y Axis',
  rotation: 'Rotation',
  width: 'Width',
  height: 'Height',
  opacity: 'Opacity',
  blendMode: 'Blend mode',
  radius: 'Radius',
  cornerSmoothing: 'Corner smoothing',
  spread: 'Spread',

  page: 'Page',
  frame: 'Frame',
  framePreset: 'Frame preset',
  framePresetCustom: 'Custom',
  framePresetCategoryPhone: 'Phone',
  framePresetCategoryTablet: 'Tablet',
  framePresetCategoryDesktop: 'Desktop',
  framePresetCategoryPresentation: 'Presentation',
  framePresetCategoryWatch: 'Watch',
  framePresetCategoryPaper: 'Paper',
  framePresetCategorySocialMedia: 'Social media',
  framePresetCategoryFigmaCommunity: 'Figma Community',
  framePresetCategoryArchive: 'Archive',
  position: 'Position',
  layout: 'Layout',
  autoLayout: 'Auto layout',
  alignment: 'Alignment',
  appearance: 'Appearance',
  fill: 'Fill',
  stroke: 'Stroke',
  selectionColors: 'Selection colors',
  effects: 'Effects',
  mask: 'Mask',
  export: 'Export',
  moreEllipsis: 'More…',
  make: 'Make',
  makeDescription:
    'Export the selection as React Tailwind JSX, then let AI add interactivity (Figma Make–style).',
  makePreview: 'Make',
  makeWithAi: 'Make with AI',
  makeNeedsAi: 'Configure an AI chat provider in Settings to refine the prototype.',
  makeBuilding: 'Building…',
  makePreviewTitle: 'Make',
  makePreviewHint:
    'Uses the open design tab. Chat generates project files; preview runs on fe-esbuild-package.',
  makePreviewScreensHint: params('{count} screens in the selection.'),
  makeRefreshPreview: 'Refresh preview',
  makeClosePreview: 'Close Make',
  makeBackToDesign: 'Back to design',
  makeCodeLabel: 'Code',
  makeCodeFiles: 'Project files',
  makeLockFromServer: 'package-lock.json is generated by the build server, not AI.',
  makeBuiltinSkills: 'Built-in',
  makeChatTitle: 'Chat',
  makeSidePanel: 'Chat and code',
  makeSelectedNodes: 'Selection',
  makeSelectedNodesEmpty: 'Nothing selected in the design tab.',
  makeSelectedNodesCount: params('{count} selected'),
  makeSelectedNodesSummaryOne: params('{name}'),
  makeSelectedNodesSummaryMany: params('{count} selected · {name}…'),
  makeSelectedNodesDialogTitle: 'Selected layers',
  makeSelectedNodesLoading: 'Loading previews from the design tab…',
  makeNodePreviewMissing: 'No preview',
  makePrototypeDisconnected:
    'Cannot reach the design tab. Keep the prototype open, then reopen Make.',
  makeWaitingForChat: 'Send a chat message so skills can author the Make project.',
  makeCodePlaceholder: 'Project files appear here after skills generate them…',
  makeSandboxMissing: 'Set MAKE_SANDBOX_SERVER_URL in app config to preview.',
  makeSandboxBundling: 'Bundling sandbox…',

  typography: 'Typography',
  fontFamily: 'Font family',
  fontWeight: 'Font weight',
  fontSize: 'Font size',
  lineHeight: 'Line height',
  letterSpacing: 'Letter spacing',
  textAlignment: 'Text alignment',
  verticalTextAlignment: 'Vertical text alignment',
  textCase: 'Text case',
  textCaseOriginal: 'Original',
  textCaseUpper: 'Uppercase',
  textCaseLower: 'Lowercase',
  textCaseTitle: 'Title case',
  truncation: 'Truncation',
  truncationDisabled: 'Disabled',
  truncationEnding: 'Ending ellipsis',
  maxLines: 'Maximum lines',
  openTypeFeatures: 'Font features',
  standardLigatures: 'Standard ligatures',
  contextualAlternates: 'Contextual alternates',
  kerning: 'Kerning',
  textFormatting: 'Text formatting',
  pageBackground: 'Page background',
  variables: 'Variables',
  variants: 'Variants',
  componentProperties: 'Component properties',
  constraints: 'Constraints',
  horizontalConstraint: 'Horizontal constraint',
  verticalConstraint: 'Vertical constraint',
  constraintLeft: 'Left',
  constraintRight: 'Right',
  constraintTop: 'Top',
  constraintBottom: 'Bottom',
  constraintCenter: 'Center',
  constraintLeftAndRight: 'Left and right',
  constraintTopAndBottom: 'Top and bottom',
  constraintScale: 'Scale',
  constraintHorizontalCenter: 'Horizontal center',
  constraintVerticalCenter: 'Vertical center',

  addFill: 'Add fill',
  addStroke: 'Add stroke',
  addEffect: 'Add effect',
  addExport: 'Add export',
  removeFill: 'Remove fill',
  removeStroke: 'Remove stroke',
  removeEffect: 'Remove effect',
  removeExport: 'Remove export',
  effectSettings: 'Effect settings',
  expandEffectSettings: 'Expand effect settings',
  collapseEffectSettings: 'Collapse effect settings',
  toggleExportPreview: 'Toggle export preview',

  dropShadow: 'Drop shadow',
  innerShadow: 'Inner shadow',
  layerBlur: 'Layer blur',
  backgroundBlur: 'Background blur',
  foregroundBlur: 'Foreground blur',

  maskType: 'Mask type',
  maskTypeAlpha: 'Alpha',
  maskTypeVector: 'Vector',
  maskTypeLuminance: 'Luminance',

  blendModePassThrough: 'Pass through',
  blendModeNormal: 'Normal',
  blendModeDarken: 'Darken',
  blendModeMultiply: 'Multiply',
  blendModeColorBurn: 'Color burn',
  blendModeLighten: 'Lighten',
  blendModeScreen: 'Screen',
  blendModeColorDodge: 'Color dodge',
  blendModeOverlay: 'Overlay',
  blendModeSoftLight: 'Soft light',
  blendModeHardLight: 'Hard light',
  blendModeDifference: 'Difference',
  blendModeExclusion: 'Exclusion',
  blendModeHue: 'Hue',
  blendModeSaturation: 'Saturation',
  blendModeColor: 'Color',
  blendModeLuminosity: 'Luminosity',

  strokeType: 'Stroke type',
  strokeWeight: 'Stroke weight',

  noSelection: 'No selection',
  noLocalVariables: 'No local variables',
  openVariables: 'Open variables',
  styles: 'Styles',
  localStyles: 'Local styles',
  noLocalStyles: 'No local styles',
  openStyles: 'Open styles',
  textStyles: 'Text styles',
  searchStyles: 'Search styles',
  noStylesFound: 'No styles found',
  editStyle: 'Edit style',
  deleteStyle: 'Delete style',
  detachStyle: 'Detach style',
  applyStyle: 'Apply style',
  styleGroupColor: 'Color',
  styleGroupText: 'Text',
  styleGroupEffect: 'Effect',
  styleGroupGrid: 'Layout guide',
  addPage: 'Add page',
  toggleVisibility: 'Toggle visibility',
  independentCornerRadii: 'Independent corner radii',
  detachVariable: 'Detach variable',
  applyVariable: 'Apply variable',
  noVariablesFound: 'No variables found',
  addAutoLayout: 'Add auto layout',
  removeAutoLayout: 'Remove auto layout',
  alignLeft: 'Align left',
  alignCenterHorizontally: 'Align center horizontally',
  alignRight: 'Align right',
  alignTop: 'Align top',
  alignCenterVertically: 'Align center vertically',
  alignBottom: 'Align bottom',
  flipHorizontal: 'Flip horizontal',
  flipVertical: 'Flip vertical',
  rotate90: 'Rotate 90°',
  mixedFillsHelp: 'Click + to replace mixed fills',
  mixedStrokesHelp: 'Click + to replace mixed strokes',
  mixedEffectsHelp: 'Click + to replace mixed effects',
  strokeSides: 'Stroke sides',
  strokeDash: 'Dashed stroke',
  strokeCap: 'Stroke cap',
  strokeCapButt: 'Butt cap',
  strokeCapRound: 'Round cap',
  strokeCapSquare: 'Square cap',
  strokeJoin: 'Stroke join',
  strokeJoinMiter: 'Miter join',
  strokeJoinBevel: 'Bevel join',
  strokeJoinRound: 'Round join',
  strokeMiterLimit: 'Miter limit',
  strokeAlignInside: 'Inside',
  strokeAlignCenter: 'Center',
  strokeAlignOutside: 'Outside',
  exportScale: 'Export scale',
  exportFormat: 'Export format',
  exportPreview: 'Preview',
  exportRenderingPreview: 'Rendering preview…',
  create: 'Create',
  add: 'Add',
  createVariable: 'Create variable',
  createColorVariable: params('Create color variable from {value}'),
  createNumberVariable: params('Create number variable from {value}'),
  variableName: 'Variable name',
  mixed: 'Mixed',
  none: 'None',
  createStyle: 'Create style',
  colorStyle: 'Color style',
  styleName: 'Style name',
  fillStyle: 'Fill style',
  strokeStyle: 'Stroke style',
  textStyle: 'Text style',
  effectStyle: 'Effect style',
  gridStyle: 'Grid style',
  missingStyle: params('Missing style ({id})'),
  layersCount: params('{count} layers'),
  goToMainComponent: 'Go to Main Component',
  detachInstance: 'Detach Instance',

  gap: 'Gap',

  solid: 'Solid',
  linearGradient: 'Linear',
  radialGradient: 'Radial',
  image: 'Image',
  stops: 'Stops',
  addStop: 'Add stop',

  alignCenter: 'Align center',
  alignMiddle: 'Align middle',
  clipContent: 'Clip content',
  colorFormatRgb: 'RGB',
  colorFormatHsl: 'HSL',
  colorFormatHsb: 'HSB',
  colorFormatOkhcl: 'OkHCL',
  colorHintHsl: 'H hue · S saturation · L lightness',
  colorHintHsb: 'H hue · S saturation · B brightness',
  colorHintOkhcl: 'H hue · C chroma · L lightness · A alpha',
  colorPreviewClipped: params('Clipped to {space} preview gamut'),
  rulers: 'Rulers',
  multiplayerCursors: 'Multiplayer cursors',
  direction: 'Direction',
  flow: 'Flow',
  freeform: 'Freeform',
  dimensions: 'Dimensions',
  layoutHorizontal: 'Horizontal layout',
  layoutVertical: 'Vertical layout',
  layoutGrid: 'Grid layout',
  layoutWrap: 'Wrap layout',
  gapAuto: 'Auto gap',
  horizontalGap: 'Horizontal gap',
  verticalGap: 'Vertical gap',
  auto: 'Auto',
  columns: 'Columns',
  rows: 'Rows',
  sizingFixed: 'Fixed',
  sizingHug: 'Hug',
  sizingFill: 'Fill',
  sizingHugShort: 'Hug',
  sizingFillShort: 'Fill',
  addMinWidth: 'Add min width',
  removeMinWidth: 'Remove min width',
  addMaxWidth: 'Add max width',
  removeMaxWidth: 'Remove max width',
  addMinHeight: 'Add min height',
  removeMinHeight: 'Remove min height',
  addMaxHeight: 'Add max height',
  removeMaxHeight: 'Remove max height',
  minWidthShort: 'Min W',
  maxWidthShort: 'Max W',
  minHeightShort: 'Min H',
  maxHeightShort: 'Max H',
  setToCurrentWidth: 'Set to current width',
  setToCurrentHeight: 'Set to current height',
  sizingFillFr: 'Fill (fr)',
  sizingFixedPx: 'Fixed (px)',
  resizing: 'Resizing',
  resizeAutoWidth: 'Auto width',
  resizeAutoHeight: 'Auto height',
  resizeFixed: 'Fixed size',
  layoutGrids: 'Layout guide',
  addLayoutGrid: 'Add layout guide',
  removeLayoutGrid: 'Remove layout guide',
  gridColumns: 'Columns',
  gridRows: 'Rows',
  gridGrid: 'Grid',
  gridCount: 'Count',
  gridGutter: 'Gutter',
  gridMargin: 'Margin',
  gridSectionSize: 'Section size',
  searchFonts: 'Search fonts...',
  noFontsFound: 'No fonts found',
  noLocalFontsAvailable: 'No local fonts available.',
  localFontsAccessHint: 'Use the desktop app or Chrome/Edge to access system fonts.',
  allowLocalFonts: 'Allow local fonts',
  localFontsPrompt: 'Allow local font access to browse installed fonts.',
  localFontsDenied: 'Local font access is blocked for this site.',
  localFontsUnsupported: 'Local fonts are not available in this browser.',
  editColor: 'Edit color',
  red: 'Red',
  green: 'Green',
  blue: 'Blue',
  hue: 'Hue',
  saturation: 'Saturation',
  brightness: 'Brightness',
  lightness: 'Lightness',
  chroma: 'Chroma',
  alpha: 'Alpha'
} as const

export const panelMessages = i18n('panels', panelMessageDefaults)
